/* Xsauna — smoothness layer (no visual redesign).
   1) Gentle entrance for sections that had none.
   2) Images and autoplay videos fade in when ready instead of popping in.
   Everything fails open: if anything goes wrong, content is simply shown. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Entrance for sections without Atlas animation ---------- */
  function revealPlainSections() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var sections = document.querySelectorAll('.shopify-section:not(.shopify-section-group-header-group):not(.shopify-section-group-footer-group)');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('xs-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    var vh = window.innerHeight;

    Array.prototype.forEach.call(sections, function (s) {
      if (s.querySelector('.animation-section') || s.classList.contains('animation-section')) return; // Atlas already animates it
      if (s.offsetHeight < 40) return;
      var r = s.getBoundingClientRect();
      if (r.top < vh * 0.9) return; // visible on load: leave as is, no flash
      s.classList.add('xs-rv');
      io.observe(s);
    });
    // safety: never leave anything hidden
    setTimeout(function () {
      document.querySelectorAll('.xs-rv:not(.xs-in)').forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('xs-in');
      });
    }, 4000);
  }

  /* ---------- 2+3. Images and autoplay videos fade in when ready ---------- */
  function sweep(cls) {
    document.querySelectorAll('.' + cls).forEach(function (el) { el.classList.remove(cls); });
  }
  function fadeMedia() {
    if (reduce) return;
    // one capture-phase listener catches load events from every image/video, including slider clones
    document.addEventListener('load', function (e) {
      var t = e.target; if (t && t.classList) t.classList.remove('xs-img-wait');
    }, true);
    document.addEventListener('error', function (e) {
      var t = e.target; if (t && t.classList) { t.classList.remove('xs-img-wait'); t.classList.remove('xs-vid-wait'); }
    }, true);
    ['playing', 'loadeddata'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        var t = e.target; if (t && t.classList) t.classList.remove('xs-vid-wait');
      }, true);
    });
    Array.prototype.forEach.call(document.querySelectorAll('img'), function (img) {
      if (img.complete && img.naturalWidth > 0) return;
      if (img.closest('header, .header, .announcement-bar, .cart-drawer, .drawer')) return;
      img.classList.add('xs-img-fade', 'xs-img-wait');
    });
    Array.prototype.forEach.call(document.querySelectorAll('video[autoplay]'), function (v) {
      if (v.readyState >= 2) return;
      v.classList.add('xs-vid-fade', 'xs-vid-wait');
    });
    // safety sweeps: anything already loaded, or sitting in view for a while, is shown; after 30s show everything
    var ticks = 0;
    var timer = setInterval(function () {
      ticks++;
      document.querySelectorAll('.xs-img-wait, .xs-vid-wait').forEach(function (el) {
        var loaded = el.tagName === 'IMG' ? (el.complete && el.naturalWidth > 0) : el.readyState >= 2;
        var r = el.getBoundingClientRect();
        var inView = r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth;
        if (loaded || (inView && ticks > 2)) { el.classList.remove('xs-img-wait'); el.classList.remove('xs-vid-wait'); }
      });
      if (ticks >= 30) { clearInterval(timer); sweep('xs-img-wait'); sweep('xs-vid-wait'); }
    }, 1000);
  }

  function init() {
    try { fadeMedia(); } catch (e) {}
    try { revealPlainSections(); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
